import { Controller } from "@hotwired/stimulus"

// Ensures the modal contains exactly one (new) ScaleUsage form when opened via the + overlay.
// Also removes that form if the modal is closed without the user entering anything.
export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    this.modalElement = this.element.closest(".modal")
    if (!this.modalElement) return

    this._onShown = this.ensureOne.bind(this)
    this._onHidden = this.cleanupIfBlank.bind(this)

    this.modalElement.addEventListener("shown.bs.modal", this._onShown)
    this.modalElement.addEventListener("hidden.bs.modal", this._onHidden)
  }

  disconnect() {
    if (!this.modalElement) return
    this.modalElement.removeEventListener("shown.bs.modal", this._onShown)
    this.modalElement.removeEventListener("hidden.bs.modal", this._onHidden)
  }

  ensureOne() {
    if (!this.hasContainerTarget || !this.hasTemplateTarget) return

    // A leftover draft from a canceled open belongs to the wheel it was
    // started for. Reopening via a DIFFERENT wheel must not carry its
    // scale along — start that wheel fresh instead.
    const pending = this.modalElement.dataset.pendingWheel
    const leftoverField = this.containerTarget.querySelector("[data-wheel-field]")
    if (leftoverField && pending !== undefined && leftoverField.value !== pending) {
      this.containerTarget.innerHTML = ""
    }

    if (this.containerTarget.children.length === 0) {
      // Only the usage's own placeholder: the readings template nested in it
      // keeps NEW_RECORD for nested-form#add, so every added reading gets its
      // own index instead of all sharing this one (last one would win on save).
      const content = this.templateTarget.innerHTML.replace(/NEW_USAGE/g, Date.now().toString())
      this.containerTarget.insertAdjacentHTML("beforeend", content)
    }

    // Apply the wheel the user clicked (stamped by gear-modal#open before
    // the form existed).
    const wheelField = this.containerTarget.querySelector("[data-wheel-field]")
    if (wheelField && pending !== undefined) {
      wheelField.value = pending
    }
  }

  cleanupIfBlank() {
    if (!this.hasContainerTarget) return
    if (this.containerTarget.children.length !== 1) return

    const root = this.containerTarget.children[0]
    const fields = root.querySelectorAll("input, select, textarea")

    const hasValue = Array.from(fields).some((el) => {
      if (el.type === "hidden") return false
      if ((el.name || "").endsWith("[_destroy]")) return false
      return (el.value || "").trim() !== ""
    })
    // Captured photo evidence counts as content: the draft must survive so
    // its pending attachment still links to the reading on save.
    const hasEvidence = !!root.querySelector(".reading-thumb")

    if (!hasValue && !hasEvidence) this.containerTarget.innerHTML = ""
  }
}
